<div class="variant-snackbar">
    <div class="variant-snackbar-container">
        <div class="message">Size chart has been deleted</div>
        <div (click)="undoDeleteImage()" class="variant-undo">Undo</div>
        <mat-icon
            class="variant-snackbar-close"
            (click)="closeDeleteAlertSnackBar()"
            >close</mat-icon
        >
    </div>
</div>
